export * from './lib/clipboard.module';
